import { ShoppingBag, Package, Users, Receipt, BarChart3, Settings, ClipboardList, TrendingUp } from 'lucide-react';

export const WHATSAPP = 'https://wa.me/8801894550484';

// Full class strings (statically present) so Tailwind's JIT scanner includes them
export const ICON_BG = {
  blue:    'from-blue-500 to-blue-600 shadow-blue-500/10',
  violet:  'from-violet-500 to-violet-600 shadow-violet-500/10',
  amber:   'from-amber-500 to-amber-600 shadow-amber-500/10',
  indigo:  'from-indigo-500 to-indigo-600 shadow-indigo-500/10',
  emerald: 'from-emerald-500 to-emerald-600 shadow-emerald-500/10',
};

export const FEAT_KEYS = [
  { key: 'orders',    icon: ShoppingBag, color: 'blue' },
  { key: 'inventory', icon: Package,     color: 'emerald' },
  { key: 'customers', icon: Users,       color: 'violet' },
  { key: 'expenses',  icon: Receipt,     color: 'amber' },
  { key: 'reports',   icon: BarChart3,   color: 'indigo' },
];

export const STEP_KEYS = ['s1', 's2', 's3'];
export const STEP_ICONS = [Settings, ClipboardList, TrendingUp];
export const STEP_NUMS = ['০১', '০২', '০৩'];
export const STEP_NUMS_EN = ['01', '02', '03'];
